// DS: i12.2
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const StudioDiscount: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="currentColor"
          d="M15.699 9.696a.999.999 0 0 0-1.413-1.413l-6.001 6.001a.999.999 0 0 0 1.412 1.413zM11.068 9.683a1.385 1.385 0 1 1-2.77 0 1.385 1.385 0 0 1 2.77 0M14.3 15.683a1.385 1.385 0 1 0 0-2.77 1.385 1.385 0 0 0 0 2.77"
        ></path>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M12 2a3.2 3.2 0 0 0-2.268.942v.001l-.697.697a1.2 1.2 0 0 1-.846.35h-1a3.2 3.2 0 0 0-3.2 3.199v1c0 .316-.125.62-.348.845l-.001.001-.697.696v.001a3.2 3.2 0 0 0 0 4.536l.697.697c.224.226.349.53.35.846v1a3.2 3.2 0 0 0 3.199 3.2h1c.316 0 .62.125.845.349h.001l.696.697h.001a3.2 3.2 0 0 0 4.536 0l.697-.697c.226-.224.53-.35.847-.35h1a3.2 3.2 0 0 0 3.199-3.199v-1c0-.316.125-.62.348-.845l.001-.001.697-.696v-.001a3.2 3.2 0 0 0 0-4.536l-.697-.697a1.2 1.2 0 0 1-.35-.847v-1a3.2 3.2 0 0 0-3.199-3.199h-1c-.316 0-.62-.125-.845-.348l-.001-.001-.696-.697h-.001A3.2 3.2 0 0 0 12 2m-.461 2.09a1.2 1.2 0 0 1 1.313.262l.002.002.7.7.002.002a3.2 3.2 0 0 0 2.255.931h1a1.2 1.2 0 0 1 1.202 1.202v1a3.2 3.2 0 0 0 .93 2.255l.003.002.7.7.002.002a1.2 1.2 0 0 1 0 1.704l-.002.002-.7.7-.002.002a3.2 3.2 0 0 0-.931 2.255v1a1.2 1.2 0 0 1-1.202 1.202h-1a3.2 3.2 0 0 0-2.255.93l-.002.003-.7.7-.002.002a1.2 1.2 0 0 1-1.704 0l-.702-.702-.002-.002a3.2 3.2 0 0 0-2.255-.931h-1a1.2 1.2 0 0 1-1.202-1.202v-1a3.2 3.2 0 0 0-.93-2.255l-.703-.702-.002-.002a1.2 1.2 0 0 1 0-1.704l.002-.002.7-.7.002-.002a3.2 3.2 0 0 0 .931-2.255v-1A1.2 1.2 0 0 1 7.19 5.987h1a3.2 3.2 0 0 0 2.255-.93l.002-.003.7-.7.002-.002a1.2 1.2 0 0 1 .39-.262"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};

export default StudioDiscount;
